/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 10.25C0 15.9109 4.589 20.5 10.25 20.5a.75.75 0 0 0 0-1.5c-.1864 0-.4579-.1-.7968-.4892-.3375-.3874-.6755-.9913-.9743-1.8026-.5367-1.4568-.901-3.455-.9678-5.7082H19.75a.75.75 0 0 0 .75-.75C20.5 4.589 15.9109 0 10.25 0 4.589 0 0 4.589 0 10.25Zm9.4532-8.2608c.339-.3892.6104-.4892.7968-.4892.1864 0 .4579.1.7968.4892.3375.3874.6754.9913.9743 1.8026.5367 1.4568.9011 3.455.9678 5.7082H7.5111c.0667-2.2532.431-4.2514.9678-5.7082.2988-.8113.6369-1.4152.9743-1.8026ZM6.0104 9.5c.067-2.3951.4527-4.5758 1.061-6.2268.188-.5102.4017-.9822.6416-1.3997C4.3476 2.8914 1.8388 5.8819 1.5317 9.5h4.4787ZM1.5317 11h4.4787c.067 2.3951.4527 4.5758 1.061 6.2268.188.5101.4017.9822.6416 1.3997C4.3476 17.6086 1.8388 14.6181 1.5317 11Zm17.4366-1.5c-.3071-3.6181-2.8159-6.6086-6.1813-7.6265.2399.4175.4537.8895.6416 1.3997.6083 1.651.994 3.8317 1.061 6.2268h4.4787Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.1497 13.3496c-.3285-.7106.2952-1.4912 1.0608-1.3276l10.8753 2.3235c.7593.1622 1.0139 1.1173.4362 1.636l-1.7286 1.5516 2.852 2.2788a.95.95 0 0 1 .1492 1.3352l-1.9675 2.4624c-.3276.4099-.9253.4767-1.3352.1492l-2.852-2.2788-1.1319 2.0284c-.3784.678-1.3661.6405-1.6919-.0643l-4.6664-10.0944Zm1.8231.3691 3.7516 8.1155.922-1.6522c.286-.5126.9639-.6457 1.4226-.2792l2.9295 2.3407 1.2809-1.6031-2.9296-2.3407c-.4586-.3664-.4784-1.057-.0416-1.4491l1.408-1.2639-8.7434-1.868Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuSubDomains'
);
